<div class="table-view busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
      <div>{{errorMsg}}</div>
      <div class="">
          <i class="fa fa-times" role="button" (click)="errorMsg=null"></i>
      </div>
    </div>

    <div class="table-view-header-controls" style="position:sticky;left:0;">
    <div class="d-flex flex-wrap">
      <div style="font-size:18px;font-weight: bold;">
        Stage {{stages.join(',')||columnByName['stage']?.filter?.value}}
        Building Summary -
        {{buildingIds.join(',')||columnByName['buildingid']?.filter?.value}} -
        {{participants.join(',')||columnByName['participant']?.filter?.value}}
      </div>
      <div class="d-flex flex-row">
        <ng-template #configModal>
          <div class="m-0 p-1 modal-header font-weight-bold" style="background-color: #CFD5EA;">
            Table Options
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeConfigModal(configComponent)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <fes-table-view-config #configComponent [table]="this" [pagingEnabled]="false"
                (filterKeyUp)="$event.event.key=='Enter'&&closeConfigModal(configComponent)">
            </fes-table-view-config>
          </div>
          <div class="m-0 p-1 modal-footer d-flex flex-row justify-content-between">
            <button class="btn btn-warning" (click)="closeConfigModal(configComponent)">Close</button>
          </div>
        </ng-template>
        <div class="pl-2 my-auto small">
          <a href="javascript:false;" (click)="showConfigModal(configModal)">
            <i class="fa fa-filter px-sm-1"></i>
          </a>
          <a href="javascript:false;" title="download as csv" (click)="!bDownloading&&download()" [ngStyle]="{'opacity':bDownloading?'0.2':'1'}">
            <i [ngClass]="'px-sm-1 fa fa-download' + (bDownloading?' blink':'')"></i>
          </a>
          <a href="javascript:false;" (click)="!isLoading&&load()" [ngStyle]="{'opacity':isLoading?'0.2':'1'}">
            <i class="fa fa-redo px-sm-1"></i>
          </a>
        </div>
      </div>
    </div>
    </div>



    <div class="p-2 table-view-table-wrapper">
      <table class="table-view-table table table-sm">
        <thead>
          <tr>
            <th *ngFor="let column of visibleColumns;" [ngClass]="column.headerCellCssClass">
              <div>
                {{column.title}}
              </div>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="isActiveView">
          <ng-container *ngFor="let record of buildingRecs;index as index;">
            <tr *ngIf="record['summgroup']=='Building'&&record['summrow']=='CP'&&record['type']=='CP'">
              <td *ngFor="let col of columnsBeforeSummRow"><!--for excel column alignment--></td>
              <td class="pt-1 pb-0 text-left text-blue font-weight-bold">
                {{buildingById[record['buildingid']]?.market}} {{buildingById[record['buildingid']]?.morphology}}
              </td>
            </tr>
            <ng-container *ngLet="!columnByName['summgroup']?.visible&&index>0&&record.summgroup!='Building'&&record.summgroup!=buildingRecs[index-1].summgroup as isSummarySectionHeader">
              <tr *ngIf="isSummarySectionHeader">
                <td *ngFor="let col of columnsBeforeSummRow"><!--for excel column alignment--></td>
                <td class="summary-group-heading">
                  {{record.summgroup}}
                </td>
              </tr>
              <tr [ngClass]="{'strong-top-border':!isSummarySectionHeader&&index>0&&record.summgroup!='Building'&&record.type!=buildingRecs[index-1].type}">
              <ng-container *ngFor="let column of visibleColumns;">
                <td [ngSwitch]="column.template" [ngClass]="(column.dataCellCssClass||'') + ' summary-row-td-' + record.summgroup?.toLowerCase().replace(' ','-')">
                  <div *ngSwitchCase="'percent'" [ngClass]="{'text-super-muted':record[column.name]==0}">{{record[column.name]|percent:'.0-2'}}</div>
                  <div *ngSwitchCase="'numeric'" [ngClass]="record[column.name]==0?'text-super-muted':'text-blue'">{{record[column.name]||'-'}}</div>
                  <div *ngSwitchCase="'text'">{{record[column.name]}}</div>
                  <ng-container *ngSwitchCase="'summrow'" [ngSwitch]="record['summrow']">
                    <div *ngSwitchCase="'CP'">{{record['buildingid']}} CP Results</div>
                    <div *ngSwitchCase="'TB'">{{record['buildingid']}} TB Results</div>
                    <div *ngSwitchDefault>
                      {{record[column.name]}}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{record[column.name]}}
                  </ng-container>
                </td>
              </ng-container>
              </tr>
            </ng-container>
          </ng-container>


          <tr *ngIf="pathRecs.length">
            <td *ngFor="let col of columnsBeforeSummRow"><!--for excel column alignment--></td>
            <td class="summary-group-heading" [attr.colspan]="visibleColumns.length">
              Test Paths
            </td>
          </tr>

          <ng-container *ngFor="let record of pathRecs;index as index;">
            <tr *ngIf="index>0&&record.summgroup=='Path'&&pathRecs[index-1].summgroup!='Path'">
              <td *ngFor="let col of columnsBeforeSummRow"><!--for excel column alignment--></td>
              <td style="padding:6px;"></td>
            </tr>
            <tr [ngClass]="{'strong-top-border':index>0&&record.summgroup!='Path'&&record.type!=pathRecs[index-1].type}">
            <ng-container *ngFor="let column of visibleColumns;">
              <td [ngSwitch]="column.template" [ngClass]="(column.dataCellCssClass||'') + ' summary-row-td-' + record.summgroup?.toLowerCase().replace(' ','-')">
                <div *ngSwitchCase="'percent'" [ngClass]="{'text-super-muted':record[column.name]==0}">{{record[column.name]|percent:'.0-2'}}</div>
                <div *ngSwitchCase="'numeric'" [ngClass]="record[column.name]==0?'text-super-muted':'text-blue'">{{record[column.name]||'-'}}</div>
                <div *ngSwitchCase="'text'">{{record[column.name]}}</div>
                <ng-container *ngSwitchCase="'summrow'" [ngSwitch]="record['summrow']">
                  <div class="d-flex flex-row justify-content-between">
                    <ng-container *ngIf="record['summgroup']=='Path'; else notPathSummGroup">
                      <div class="text-blue">{{record.pathid}}</div>
                    </ng-container>
                    <ng-template #notPathSummGroup>
                      <div>{{record[column.name]}}</div>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>{{record[column.name]}}</ng-container>
              </td>
            </ng-container>
            </tr>
          </ng-container>

          <tr *ngIf="pointRecs.length">
            <td *ngFor="let col of columnsBeforeSummRow"><!--for excel column alignment--></td>
            <td class="summary-group-heading" [attr.colspan]="visibleColumns.length">
              Test Points
            </td>
          </tr>

          <ng-container *ngFor="let record of pointRecs;index as index;">
            <tr *ngIf="index>0&&record.summgroup=='Point'&&pointRecs[index-1].summgroup!='Point'">
              <td *ngFor="let col of columnsBeforeSummRow"><!--for excel column alignment--></td>
              <td style="padding:6px;"></td>
            </tr>
            <!--<tr *ngIf="record['pathid']&&(index==0||record.summgroup=='Point'&&pointRecs[index-1].summgroup!='Point')">
              <td *ngFor="let col of columnsBeforeSummRow"></td>
              <td class="text-left text-info font-italic small">Path {{record['pathid']}}</td>
            </tr>-->
            <tr [ngClass]="{'strong-top-border':index>0&&record.summgroup!='Point'&&record.type!=pointRecs[index-1].type}">
            <ng-container *ngFor="let column of visibleColumns;">
              <td [ngSwitch]="column.template" [ngClass]="(column.dataCellCssClass||'') + ' summary-row-td-' + record.summgroup?.toLowerCase().replace(' ','-')">
                <div *ngSwitchCase="'percent'" [ngClass]="{'text-super-muted':record[column.name]==0}">{{record[column.name]|percent:'.0-2'}}</div>
                <div *ngSwitchCase="'numeric'" [ngClass]="record[column.name]==0?'text-super-muted':'text-blue'">{{record[column.name]||'-'}}</div>
                <div *ngSwitchCase="'text'">{{record[column.name]}}</div>
                <ng-container *ngSwitchCase="'summrow'" [ngSwitch]="record['summrow']">
                  <div class="d-flex flex-row justify-content-between">
                    <ng-container *ngIf="record['summgroup']=='Point'; else notPointSummGroup">
                      <div class="text-blue">{{record.pointid}}</div>
                      <!--<div class="text-muted">All</div> not copy/paste friendly when pasting into Excel-->
                    </ng-container>
                    <ng-template #notPointSummGroup>
                      <div>{{record[column.name]}}</div>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>{{record[column.name]}}</ng-container>
              </td>
            </ng-container>
            </tr>
          </ng-container>

        </tbody>
      </table>
      <div *ngIf="!isLoading&&!buildingRecs.length&&!pointRecs.length" class="pt-2 text-center text-warning">
        No Correlation Data Found.
      </div>
    </div>
    <div style="position:sticky;left:0;font-weight:bold;" class="py-2 small">
      <a href="javascript:false;" (click)="!isLoading&&load()" [ngStyle]="{'opacity':isLoading?'0.2':'1'}">
        <i class="fa fa-redo px-sm-1 pr-1"></i>Refresh
      </a>
    </div>
  </div>

